export const SCORE_STATUS = {
  NOT_STARTED: 'not-started',
  NOT_FINISHED: 'not-finished',
  PENDING_GRADING: 'pending-grading',
  BUSY: 'busy',
  FINISHED: 'finished',
} as const;
